import { Link } from 'react-router-dom'

import OrderStatus from '@/components/Orders/OrderStatus/OrderStatus'
import { OrderShortType } from '@/types'
import { trimTrailingZeros } from '@/utils/format/trimTrailingZeros'

import cn from './ConstructionSite.module.scss'

export const columns = [
  {
    title: '№ Заказа',
    key: 'code',
    dataIndex: 'code',
    render: (code: number) => (
      <Link to={`/profile/orders/${code}`} className={cn.orderLink}>
        №{code}
      </Link>
    ),
  },
  {
    title: 'Дата',
    key: 'createdAt',
    dataIndex: 'createdAt',
    render: (date: string) => new Date(date).toLocaleDateString('ru-RU'),
  },
  {
    title: 'Статус',
    key: 'orderStatus',
    render: (_: unknown, record: OrderShortType) => (
      <OrderStatus order={record} />
    ),
  },
  {
    title: 'Сумма, BYN',
    key: 'totalPrice',
    dataIndex: 'totalPrice',
    render: (price: number) => (price != null ? trimTrailingZeros(price) : '0'),
  },
  {
    title: 'Комментарий',
    key: 'comment',
    dataIndex: 'comment',
    ellipsis: true, // Обрезает длинный текст
  },
]
